import React, { useState,useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import QRCode from "qrcode";

const PreviewAmg = ({ show, onHide, content, count = 1, scale }) => {

  
    // console.log('content ', content)
  
    const [qrCode, setQrCode] = useState("");
  
    // ============================================================
    // GENERATE QR CODE
    // ============================================================
    useEffect(() => {
      const generateQR = async () => {
        try {
          // ========================================================
          // QR CODE NOW LINKS TO LERROS CONTACT PAGE
          // Scanning this QR code will open the Lerros HQ contact page
          // ========================================================
          const qrData = "https://company.lerros.com/de/kontakt/zentrale";
  
          const qr = await QRCode.toDataURL(qrData, {
            width: 150,
            margin: 0,
            errorCorrectionLevel: "M",
          });
  
          setQrCode(qr);
        } catch (error) {
          console.error("QR Code generation error:", error);
          setQrCode("");
        }
      };
  
      generateQR();
    }, []);

  const sinf = content?.SINF || "";

  const header = [...(content?.header || [])];
  const TotalQtys = [...(content?.TotalQtys || [])];

  const qty = TotalQtys[TotalQtys.length - 1];

  header.pop();
  TotalQtys.pop();

  // Combine headers and quantities, excluding zeros
  const combinedData = [];

  for (let i = 0; i < Math.min(header.length, TotalQtys.length); i++) {
    const qty = Number(TotalQtys[i]);
    if (qty !== 0) {
      combinedData.push({
        header: header[i],
        quantity: qty,
      });
    }
  }

  const headers1 = combinedData.slice(0, 6).map((item) => item.header);
  const quantities1 = combinedData.slice(0, 6).map((item) => item.quantity);
  const headers2 = combinedData.slice(6, 12).map((item) => item.header);
  const quantities2 = combinedData.slice(6, 12).map((item) => item.quantity);

  const tableHeader1 = headers1
    .map((dt) => `<td class="size_col">${dt}</td>`)
    .join("");
  const tableHeader2 = headers2
    .map((dt) => `<td class="size_col">${dt}</td>`)
    .join("");
  const tableData1 = quantities1
    .map((dt) => `<td class="size_col">${dt} </td>`)
    .join("");
  const tableData2 = quantities2
    .map((dt) => `<td class="size_col">${dt} </td>`)
    .join("");

  const createValidSizeListString = (data) => {
    if (!data?.TotalQtys || !data?.header)
      return { valid_sizelist: "", valid_sizevalues: "" };

    const sizArr = data.TotalQtys;
    const new_size_list = [];
    const default_size_list = [];

    for (let i = 0; i < 12; i++) {
      if (sizArr[i] !== 0) {
        new_size_list.push(sizArr[i]);
        default_size_list.push(data.header[i]);
      }
    }

    const valid_sizelist = default_size_list.join(" + ");
    const valid_sizevalues = new_size_list.join(" + ") + " = " + sizArr[12];
    return { valid_sizelist, valid_sizevalues };
  };

  const carton_size = `${content?.length} X ${content?.width} X ${content?.height}`;

  const { valid_sizelist, valid_sizevalues } =
    createValidSizeListString(content);

  const tbl = `
    <div class="main_container">

      <div class="qr-main-div">
        <div class="container_1_main">
          <div class="carton_no">${content?.SNO ||""} (A)</div>
          <div class="container_1">
            <div class="container_1_main_line">
              <div id="container_1_left_side">STYLE NO</div>
              <div id="container_1_middle_side">:</div>
              <div id="container_1_right_side">${content?.STY || "STY"}</div>
            </div>
            <div class="container_1_main_line">
              <div id="container_1_left_side">COL. NO</div>
              <div id="container_1_middle_side">:</div>
              <div id="container_1_right_side">${content?.CLRS || "000"}</div>
            </div>
            ${
              content?.DIM
                ? ` <div class="container_1_main_line">
              <div id="container_1_left_side">DIM</div>
              <div id="container_1_middle_side">:</div>
              <div id="container_1_right_side">${content?.DIM || ""}</div>
            </div>
              `
                : ""
            }

            <div class="container_1_main_line">
              <div id="container_1_left_side">P.O. NO</div>
              <div id="container_1_middle_side">:</div>
              <div id="container_1_right_side">${content?.PO || ""}</div>
            </div>
            <div class="container_1_main_line">
              <div id="container_1_left_side">LOT NO</div>
              <div id="container_1_middle_side">:</div>
              <div id="container_1_right_side">${content?.LOTS || ""}</div>
            </div>
            <div class="container_1_main_line">
              <div id="container_1_left_side">CARTON NO.</div>
              <div id="container_1_middle_side">:</div>
              <div id="container_1_right_side">${content?.SNO || ""}</div>
            </div>

            <div class="container_1_main_line_2">
              <table>
                  <thead>
                  <tr>
                  ${tableHeader1 || ""}
                  </tr>
                  </thead>
                  <tr>${tableData1 || ""} </tr>
                  </table>
                </div>
                <div class="container_1_main_line_2">
                  <table>
                  <thead>
                  <tr>
                  ${tableHeader2 || ""}
                  </tr>
                  </thead>
                  <tr>${tableData2 || ""} </tr>
                  </table>
            </div>

            <div class="container_1_main_line">
              <div id="container_1_left_side">QUANTITY PCS</div>
              <div id="container_1_middle_side">:</div>
              <div id="container_1_right_side">${content ? qty : ""}</div>
            </div>
            <div class="container_1_main_line">
              <div id="container_1_left_side">NUMBER OF LOTS</div>
              <div id="container_1_middle_side">:</div>
              <div id="container_1_right_side">${content?.NoOfLots || ""}</div>
            </div>
            <div class="container_1_main_line">
              <div id="container_1_left_side">CUSTOMER</div>
              <div id="container_1_middle_side">:</div>
              <div id="container_1_right_side">${content?.FCUS || ""}</div>
            </div>
          </div>
          <div class="second_barcode">
            // <div class="common-cell barcode-cell" id="barcode">
            //   ${content?.svg}
            // </div>
          </div>
        </div>
        <div class="qr-main">
        <div class="carton-id">${content?.carton_ID}</div>
          <img
            src="${qrCode}"
            class="qr-code"
            alt="QR Code"
          />
        </div>
      </div>

      <div class="qr-main-div">
        <div class="container_third">
          <div class="carton_no">${content?.SNO || ""} (B)</div>
          <div class="third_main">
            <div class="third_one">
              <div class="third_1">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                <path d="M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160l56 0 0 192-56 0c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4l-56 0 0-192 56 0c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"/>
              </svg>
              </div>
              <div class="third_2">STACK<br />STAPELN</div>
              <div class="third_1">
                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                <path d="M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160l56 0 0 192-56 0c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4l-56 0 0-192 56 0c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"/>
              </svg>
              </div>
            </div>
            <div class="third_second">
              <table class="third_table">
                <tr><p style="font-size: 20px; padding-left:2%; font-weight: bold;">LERROS MODEN GMBH</p></tr>

                <tr>
                  <th id="third_data">CARTON NO.</th>
                  <th id="third_">:</th>
                  <th id="third_data1">${content?.SNO || ""}</th>
                </tr>
                <tr>
                  <th id="third_data">MEASUREMENT</th>
                  <th id="third_">:</th>
                  <th id="third_data1">${content ? carton_size : ""} CM</th>
                </tr>
                <tr>
                  <th id="third_data">N.W.</th>
                  <th id="third_">:</th>
                  <th id="third_data1">${content?.NetWt || ""} KGS</th>
                </tr>
                <tr>
                  <th id="third_data">G.W.</th>
                  <th id="third_">:</th>
                  <th id="third_data1">${content?.GrossWt || ""} KGS</th>
                </tr>
              </table>
            </div>
          </div>
          <div class="second_barcode">
            <div class="common-cell barcode-cell" id="barcode">
              // ${content?.svg}
            </div>
          </div>
        </div>
        <div class="qr-main">
            <div class="carton-id">${content?.carton_ID}</div>
          <img
            src="${qrCode}"
            class="qr-code"
            alt="QR Code"
          />
        </div>
      </div>

      <div class="qr-main-div">
        <div class="container_second">
          <div class="carton_no">${content?.SNO || ""}(C)</div>
          <div class="container_second_">
           <div class="third_1">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                <path d="M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160l56 0 0 192-56 0c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4l-56 0 0-192 56 0c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"/>
              </svg>
              </div>
              <div class="third_2">STACK<br />STAPELN</div>
              <div class="third_1">
                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                <path d="M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160l56 0 0 192-56 0c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4l-56 0 0-192 56 0c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"/>
              </svg>
              </div>
          </div>
          <div class="second_barcode">
            <div class="common-cell barcode-cell" id="barcode">
              // ${content?.svg}
            </div>
          </div>
        </div>
        <div class="qr-main">
            <div class="carton-id">${content?.carton_ID}</div>
          <img
            src="${qrCode}"
            class="qr-code"
            alt="QR Code"
          />
        </div>
      </div>

      <div class="qr-main-div">
        <div class="container_1_main">
          <div class="carton_no">${content?.SNO || ""} (D)</div>
          <div class="container_1">
            <div class="container_1_main_line">
              <div id="container_1_left_side">STYLE NO</div>
              <div id="container_1_middle_side">:</div>
              <div id="container_1_right_side">${content?.STY || ""}</div>
            </div>
            <div class="container_1_main_line">
              <div id="container_1_left_side">COL. NO</div>
              <div id="container_1_middle_side">:</div>
              <div id="container_1_right_side">${content?.CLRS || ""}</div>
            </div>
            ${
              content?.DIM
                ? ` <div class="container_1_main_line">
              <div id="container_1_left_side">DIM</div>
              <div id="container_1_middle_side">:</div>
              <div id="container_1_right_side">${content?.DIM || ""}</div>
            </div>
              `
                : ""
            }
            <div class="container_1_main_line">
              <div id="container_1_left_side">P.O. NO</div>
              <div id="container_1_middle_side">:</div>
              <div id="container_1_right_side">${content?.PO || ""}</div>
            </div>
            <div class="container_1_main_line">
              <div id="container_1_left_side">LOT NO</div>
              <div id="container_1_middle_side">:</div>
              <div id="container_1_right_side">${content?.LOTS || ""}</div>
            </div>
            <div class="container_1_main_line">
              <div id="container_1_left_side">CARTON NO.</div>
              <div id="container_1_middle_side">:</div>
              <div id="container_1_right_side">${content?.SNO || ""}</div>
            </div>

            <div class="container_1_main_line_2">
              <table>
                  <thead>
                  <tr>
                  ${tableHeader1 || ""}
                  </tr>
                  </thead>
                  <tr>${tableData1 || ""} </tr>
                  </table>
                </div>
                <div class="container_1_main_line_2">
                  <table>
                  <thead>
                  <tr>
                  ${tableHeader2 || ""}
                  </tr>
                  </thead>
                  <tr>${tableData2 || ""} </tr>
                  </table>
            </div>

            <div class="container_1_main_line">
              <div id="container_1_left_side">QUANTITY PCS</div>
              <div id="container_1_middle_side">:</div>
              <div id="container_1_right_side">${content ? qty : ""}</div>
            </div>
            <div class="container_1_main_line">
              <div id="container_1_left_side">NUMBE OF LOTS</div>
              <div id="container_1_middle_side">:</div>
              <div id="container_1_right_side">${content?.NoOfLots || ""}</div>
            </div>
            <div class="container_1_main_line">
              <div id="container_1_left_side">CUSTOMER</div>
              <div id="container_1_middle_side">:</div>
              <div id="container_1_right_side">${content?.FCUS || ""}</div>
            </div>
          </div>
          <div class="second_barcode">
            <div class="common-cell barcode-cell" id="barcode">
              // ${content?.svg}
            </div>
          </div>
        </div>
        <div class="qr-main">
            <div class="carton-id">${content?.carton_ID}</div>
          <img
            src="${qrCode}"
            class="qr-code"
            alt="QR Code"
          />
        </div>
      </div>

    </div>
  `;

  const htmlContent = `<html lang="en">
    <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Complex Table with Flexbox</title>
 <style>
    ._main_ {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 1% 0%;
    }
    .main_container {
      width: 100%;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      flex-direction: column;
      height: fit-content;
    }
    .container_1_main {
      width: 300px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 0.3%;
      height: fit-content;
    }
    .common-cell {
      display: flex;
      flex-direction: column;
      text-align: center;
      height: 15vh;
    }

    .container_1 {
      border: 2px solid black;
      padding: 1%;
      width: 80%;
    }
    .container_1_main_line {
      display: flex;
      width: 99.5%;
      justify-content: space-between;
      align-items: center;
    }
    #container_1_left_side {
      width: 60%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      text-transform: uppercase;
      font-size: 15px;
      font-weight: 600;
    }
    #container_1_middle_side {
      width: 5%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    #container_1_right_side {
      width: 45%;
      display: flex;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;
      text-align: center;
      font-size: 15px;
      font-weight: 600;
    }
    .container_1_main_line_2 {
    }
    #container_1_main_line_data {
      height: 5vh;
      width: 99.5%;
      display: flex;
    }
    #size_chart {
      border: 1px solid black;
      width: 30%;
      height: 4.5vh;
    }
    .container_third {
      display: flex;
      align-items: center;
      flex-direction: column;
      width: 300px;
    }

    .third_main {
      border: 2px solid black;
      height: 32vh;
      width: 80%;
      display: flex;
      flex-direction: column;
      align-items: normal;
    }

    .third_one {
      height: 13vh;
      display: flex;
      width: 99%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .third_1 {
      width: 25%;
      font-size: 54px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .third_2 {
      width: 100%;
      font-size: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      font-weight: bold;
      padding: 1% 2%;
      overflow: clip
    }
    .third_3 {
      width: 25%;
    }
    .third_second {
      height: 7vh;
    }
    .third_table {
      border: 2px solid green; 
      width: 100%;
      margin-top: 0%;
      border: none !important;
    }
    .third_table th,
    .third_table tr {
      border: none !important;
    }
    
    #third_data_ {
      text-align: start;
      font-size: 20px;
      padding: 1.5% 0%;
    }
    #third_data {
      text-align: start;
      font-size: 15px;
      padding: 1% 1%;
      width: 10%;
    }

    #third_ {
      width: 1%;
    }

    #third_data1 {
      font-size: 14px;
      padding: 0.5% 0.1%;
      width: 27%;
    }
    .container_second {
      width: 300px;
      height: fit-content !important;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-top: 0.2%;
    }

    .container_second_ {
      display: flex;
      border: 2px solid black;
      width: 80%;
      height: 32vh;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .second_left {
      width: 25%;
      height: 39vh;
      margin-top: 0%;
      font-size: 116px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .arrow {
      height: 39vh;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .second_middle {
      height: 39vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .second_one {
      height: 10vh;
      display: flex;
      justify-content: center;
      align-items: end;
      font-size: 40px;
      font-weight: bold;
    }

    .second_two {
      height: 13vh;
      display: flex;
      justify-content: center;
      align-items: start;
      font-size: 35px;
      font-weight: bold;
    }

    .third_last {
      border: 2px solid black;
      width: 25%;
      height: 44vh;
      margin-top: 2%;
    }
    .container_4 {
      width: 25%;
      height: 50vh;
    }
    .cut_line_main {
      background: #f0f0f0;
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      height: 3vh;
      margin: 2% 0% 2% 0%;
    }
    #cut_logo {
      width: 2%;
      height: 3vh;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .cut_line {
      border-bottom: 1px dashed black;
      width: 98%;
      height: 0.1vh;
    }
    .second_barcode {
      width: 100%;
      display:none;
    }

      .second_left {
        font-size: 15px;
        width: 50px;
        height: 100px;
        margin: 5px;
      }
      .second_one,
      .second_two {
        font-size: 50px;
      }

      #container_1_main_line_data {
        height: 3vh;
      }
      #size_chart {
        height: 3vh;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        font-size: 18px;
        width: 15%;
      }
      #container_1_left_side {
        font-size: 15px;
        width: 70%;
      }
      .third_main {
        height: 40vh;
      }
      .third_one {
        height: 13vh;
      }
      #third_table {
        width: 100%;
      }
        #third_data{
        padding-left : 2%;
        }
      #third_data1,
      #third_data {
        font-size: 15px;
      }
      .container_1_main_line_2 {
        margin-top: 2%;
        margin-bottom: 1%;
      }
      .carton_no {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        font-weight: bold;
        width: 100%;
      }
      .cut_line_main {
        margin: 3% 0%;
      }
        .size_col{
            border : 2px solid black ;
            text-align : center ;
            width : 70px ;
            height : 30px;
            padding : 1px;
        }
        .qr-main-div {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  // border: 2px solid green;
}

.qr-main {
  width: auto;
  display: flex;
  justify-content: start;
  align-items: start;
  // border: 2px solid red;
  flex-direction: column;
}

  .carton-id{
        padding: 0px 0px 10px 0px;
        font-weight: 500;
        font-size: 13px;
      }
    
      .qr-code {
         width: 68px;
         height: 70px;
         display: block;
         object-fit: contain;
        }

  </style>

  </head>
      <body>
        <div class="tables-container">
              ${tbl}
        </div>
      </body>
  </html>`;
  return (
      <div
        style={{
          width: "auto",
          height: "auto",
          overflow: "visible",
          zoom: scale,
          padding: "100px",
          boxSizing: "border-box",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        dangerouslySetInnerHTML={{
          __html: htmlContent,
        }}
      />
  );
};

export default PreviewAmg;